module.exports = __webpack_public_path__ + "img/title4.f46cd63a.png";